import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ConnectionAuthModel, ConnectionAuthProvider } from '@libs/shared/models';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentGuardService implements CanActivate {
  public constructor(private readonly authProvider: ConnectionAuthProvider, private readonly router: Router) {
  }

  public async canActivate(): Promise<boolean | UrlTree> {
    const auth: ConnectionAuthModel = await firstValueFrom(this.authProvider.getAuth());
    
    if (auth.token?.type === 'llDirectoryUser') {
      return true;
    }

    return this.router.createUrlTree(['']);
  }
}
